import React from "react";
import SectionHeader from "../components/SectionHeader";

const FounderTeamSection = ({ data }) => {
    const isFounderPage = window.location.pathname === "/rect/founder";

    return (
        <section className="founding-team-section" id="founding-team">

            <div className="container">

                <SectionHeader
                    title={data.title}
                    description={data.description}
                />

                <div className="founding-team-grid">

                    {(data.items || []).map((item, i) => (
                        <div
                            className={`founder-card ${
                                item.featured ? "founder-card-featured" : ""
                            }`}
                            key={i}
                        >

                            <div className="founder-card-image">

                                {item.image && (
                                    <img
                                        src={item.image}
                                        alt={item.alt || item.name}
                                    />
                                )}

                            </div>

                            <div className="founder-card-content">

                                {item.role && (
                                    <span className="founder-role">
                                        {item.role}
                                    </span>
                                )}

                                <h3>{item.name}</h3>

                                {item.description && (
                                    <p>{item.description}</p>
                                )}

                            </div>

                        </div>
                    ))}

                </div>

                {/* Hide footer on /rect/founder */}
                {!isFounderPage && (
                    <div className="founding-team-footer">

                        {data.footer && (
                            <p>{data.footer}</p>
                        )}

                        {data.button && (
                            <a
                                href="/rect/founder"
                                className="founder-button"
                            >
                                Learn More
                            </a>
                        )}

                    </div>
                )}

            </div>

        </section>
    );
};

export default FounderTeamSection;